module.exports = __webpack_public_path__ + "img/photo_patterns.ff5fc60f.png";